import type { FC } from "react";

import { useLDClient } from "launchdarkly-react-client-sdk";

import { PageContentSkeleton } from "src/components/loading";
import { homeRoute } from "src/components/router/constants";
import { useAgenticHomeEnabled } from "src/hooks/use-agentic-home-enabled";
import { Navigate, type RouteObject } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const Overview = lazyNamed(() => import("./overview"), "Overview");

const OverviewGate: FC = () => {
  const ldClient = useLDClient();
  const isDataOverviewEnabled = useAgenticHomeEnabled();
  // Avoid a potential redirect if LD is not initialized.
  if (!ldClient) {
    return <PageContentSkeleton />;
  }
  return isDataOverviewEnabled ? (
    <Overview />
  ) : (
    <Navigate to={homeRoute} replace />
  );
};

// Redirects `/overview` to the data overview when agentic home is enabled, else home.
const LegacyOverviewRedirect: FC = () => {
  const ldClient = useLDClient();
  const isDataOverviewEnabled = useAgenticHomeEnabled();
  // Avoid a potential redirect if LD is not initialized.
  if (!ldClient) {
    return <PageContentSkeleton />;
  }
  return (
    <Navigate
      to={isDataOverviewEnabled ? "/data-overview" : homeRoute}
      replace
    />
  );
};

export const routes: RouteObject[] = [
  {
    path: "data-overview",
    spacesAccess: "hidden-from-limited-view",
    element: <OverviewGate />,
  },
  {
    path: "overview",
    spacesAccess: "hidden-from-limited-view",
    element: <LegacyOverviewRedirect />,
  },
];
